// extracted by mini-css-extract-plugin
export default {"modal":"tyziH9IcTQcbt6du4D6W","description":"EjZJJODoPKDoaWILuFOM"};